import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonComponentsModule } from '@app/common-components/common-components.module';
import { SharedComponentsModule } from '@app/shared2-components';

import { BookingFinishedComponent } from './ambassador/components/booking-finished/booking-finished.component';
import { ChooseContextComponent } from './ambassador/components/choose-context/choose-context.component';
import { ConfirmSiteVisitComponent } from './ambassador/components/confirm-site-visit/confirm-site-visit.component';
import { ScheduleOtherSiteVisitComponent } from './ambassador/components/schedule-other-site-visit/schedule-other-site-visit.component';
import { SiteVisitBookComponent } from './ambassador/components/site-visit-book/site-visit-book.component';
import { SiteVisitTermsConditionsComponent } from './ambassador/components/site-visit-terms-conditions/site-visit-terms-conditions.component';
import { ExternalOrgRoutingModule } from './external-org-routing.module';

@NgModule({
    imports: [CommonModule, SharedComponentsModule, ExternalOrgRoutingModule, CommonComponentsModule, FormsModule, SiteVisitBookComponent,
        BookingFinishedComponent,
        ConfirmSiteVisitComponent,
        SiteVisitTermsConditionsComponent,
        ChooseContextComponent,
        ScheduleOtherSiteVisitComponent],
    exports: []
})
export class ExternalOrgModule {}
